// import { post, get, getBlob } from '../../../../services/request';
import { post, get } from '../../../../services/request';

//-------------------Raw Exam Data - start----------------//
// Get all raw exam data
export const getAllRawExamData = (payload) => {
    return post(`ExamData/GetAllRawExamDataWithPagination`, payload);
};

// Export raw exam data as a binary workbook (not Base64-in-JSON) so very large
// date ranges avoid the size/memory overhead of the generic exportToCSVRequest flow.
// export const exportRawExamDataToCSV = (fromDate, toDate) => {
//     return getBlob(`ExamData/ExportToCSV`, { FromDate: fromDate, ToDate: toDate });
// };

// Raw exam data for a single record date. The export fetches one day per request so each call
// stays well under Azure App Service's 230-second request limit (see RawExamSaga.js).
export const getRawExamDataByDate = (date) => {
    return get(`ExamData/RawExamDataGetAll`, { FromDate: date, ToDate: date });
};

//refresh raw exam data
export const refreshRawExamData = (payload) => {
    // Accepts a single object: { fromDate, toDate, userId }
    const { fromDate, toDate, userId } = payload || {};

    if (!fromDate || !toDate) throw new Error('fromDate and toDate are required for refreshRawExamData');
    return post(`ExamData/ReCalculateExamDataDetailsByDate?FromDate=${fromDate}&ToDate=${toDate}&CreatedBy=${userId}`);
};
//-------------------Raw Exam Data - end----------------//